export default __webpack_public_path__ + "static/media/logo.4c752f50.png";